
// IE11 support, to load before all imports !
import 'babel-polyfill';

// IE11 does not support the method 'fetch' used by Apollo.
import "isomorphic-fetch"

import Vue from 'vue'
import router from './router/index'
import App from './App.vue'
import store from './store/store'
import { createProvider } from './vue-apollo'
import VueCookies from 'vue-cookies'

require('./../node_modules/bootstrap-4-grid/css/grid.min.css');

// Set cookie
VueCookies.config('30d');

Vue.config.productionTip = false;

Vue.use(VueCookies)

new Vue({
  router,
  store,
  apolloProvider: createProvider(),
  render: h => h(App)
}).$mount('#app');
